module.exports = __webpack_public_path__ + "static/media/presto_assistant.a947d6b4.png";